"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _buttonResetMixin = require("../buttonResetMixin");
var _disabledMixin = require("../disabledMixin");
var _focusMixin = require("../focusMixin");
var _hoverMediaQueryMixin = require("../hoverMediaQueryMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
/** @class TextButtonMixin */
/** @method */
var TextButtonMixin = function TextButtonMixin(props) {
  var buttonType = props.buttonType,
    fontType = props.fontType,
    inverse = props.inverse;
  var variant = inverse ? 'Inverse' : buttonType.charAt(0).toUpperCase() + buttonType.slice(1);
  return (0, _styledToken.default)({
    color: "TextButton.fontColor" + variant,
    colorHover: "TextButton.fontColor" + variant + "Hover",
    colorPressed: "TextButton.fontColor" + variant + "Pressed"
  }, function (_ref) {
    var color = _ref.color,
      colorHover = _ref.colorHover,
      colorPressed = _ref.colorPressed;
    return (0, _styledComponents.css)(["", " display:inline-flex;align-items:center;justify-content:center;&{text-decoration:", ";}&:active{text-decoration:", ";}&{color:", ";}&:hover{color:", ";}&:active{color:", ";}&:not(:active){", ";}", " ", " ", " ", ""], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), inverse ? 'underline' : 'none', inverse ? 'none' : 'underline', color, colorHover, colorPressed, (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("\n            text-decoration: " + (inverse ? 'none' : 'underline') + ";\n        "), (0, _focusMixin.focusMixin)(props), (0, _buttonResetMixin.buttonResetMixin)(props), (0, _disabledMixin.disabledMixin)(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.TextButtonMixin = TextButtonMixin;